<template>
    <div class="footer">
        <lxkf></lxkf>
        <div class="banxin">
            <div class="top">
                <div class="leftBox">
                    <p class="title">客服电话</p>
                    <p class="number">18175161706</p>
                    <p class="time">09:00-23:00</p>
                    <div class="consult">咨询客服</div>
                    <div @click="tolockzz" class="consult">查看资质</div>
                </div>
                <div class="centerBox">
                    <div class="qrCode">
                        <p class="title">客服微信</p>
                        <img src="../../../static/image/kfwx.jpg" alt="" />
                        <br> <br>
                        
                    </div>
                </div>

                <div class="rightBox">
                    <div class="qrCode">
                        <p class="title"> 合作洽谈</p>
                        <img src="../../../static/image/qrcode.png" alt="">
                        <br> <br>
                        
                    </div>

                </div>

            </div>


            <div class="bottom">
                <p> 公司地址：湖南省长沙市岳麓区洋湖街道潇湘南路一段508号湘熙水郡第18栋1512房</p>
                <p> 食品经营许可证 :JY14301040647876(告知承诺制) |  医疗器械经营许可证:湘长市场监械经营许20220695号</p>
                 
                <p> &copy;2004-2030 麦可思 All Rights Reserved ⋅<a href="https://beian.miit.gov.cn">
                       | 湘ICP备18018004号-1 | 湘公网安备43010402000722号</a>
                </p>
            </div>




        </div>
    </div>
</template>
<script>
import lxkf from '../../new/lxkf'
export default {
    components: { lxkf },
    data() {
        return {}
    },

    methods: {
        tolockzz() {

            this.$router.push({
                path: '/yyzz',
                query: {
                    name: "商家直营店",
                    addr: "湖南长沙"
                }
            })

        }
    }


}
</script>
<style lang="scss" scoped>
.footer {
    width: 100%;
    height: 400px;
    background-color: #000000;
    opacity: 0.82;
    color: #FFFFFF;
    overflow: hidden;

    .banxin {
        width: 1252px;
        height: 100%;
        margin: 0 auto;

        .top {
            margin-top: 60px;
            height: 50%;
            display: flex;
            margin-bottom: 38px;
            text-align: center;

            .leftBox {
                flex: 1;
                display: flex;
                flex-direction: column;

                .title {
                    font-size: 16px;
                    margin-bottom: 33px;
                }

                .number {
                    font-size: 40px;
                    margin-bottom: 12px;
                    font-weight: 500;
                }

                .time {
                    font-size: 18px;
                    margin-bottom: 33px;
                }

                .consult {
                    cursor: pointer;
                    margin: 0 auto;
                    width: 220px;
                    height: 36px;
                    line-height: 36px;

                    box-sizing: border-box;
                    opacity: 0.6;
                }
            }

            .centerBox {
                flex: 1;
                border-left: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);
                border-right: 2px solid rgba($color: #FFFFFF, $alpha: 0.15);

                p {
                    font-size: 16px;
                    line-height: 25px;
                }

                .title {
                    margin-bottom: 33px;
                }
            }

            .rightBox {
                flex: 1;
                display: flex;

                .aboutUs {
                    flex: 1;

                    p {
                        margin-bottom: 20px;
                    }

                    .title {
                        margin-bottom: 33px;
                    }
                }
            }
        }

        .qrCode {
            flex: 1;

            .title {
                margin-bottom: 33px;
            }

            img {
                width: 106px;
                height: 106px;
            }
        }

        .bottom {
            text-align: center;
            font-size: 14px;
            line-height: 24px;
            color: #cccbcb;

        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/footer.vue